import {useEffect, useRef, useState} from 'react';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
import {toast} from 'react-toastify';
import {io} from 'socket.io-client';
import {CustomInput} from '../components/ui';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const socket = io(API_BASE_URL);

const UserChat = () => {
  const loggedInUserId = localStorage.getItem('id');
  const parentId = localStorage.getItem('parentId');
  const parentName = localStorage.getItem('parentName');
  const [activeChat, setActiveChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [currentMessage, setCurrentMessage] = useState('');
  const messagesEndRef = useRef(null);
  const [unreadCounts, setUnreadCounts] = useState({});
  const [isMobileView, setIsMobileView] = useState(false);
  const [showChatPanel, setShowChatPanel] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setIsMobileView(window.innerWidth < 1024);
    };
    checkSize();
    window.addEventListener('resize', checkSize);

    return () => window.removeEventListener('resize', checkSize);
  }, []);
  const fetchUnreadCounts = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'user', 'message', false) +
          `/unread-count/${loggedInUserId}`
      );
      const counts = {};
      response.data.forEach((item) => {
        counts[item._id] = item.count;
      });
      setUnreadCounts(counts);
    } catch (error) {
      console.error('Failed to fetch unread counts', error);
    }
  };
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({behavior: 'smooth'});
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    // Assuming adminId and adminName are stored in localStorage

    if (!isMobileView && parentId && parentName) {
      setActiveChat({
        type: 'admin',
        id: parentId,
        name: parentName,
      });
      setShowChatPanel(true);
    }
  }, [isMobileView]);
  // ✅ Fetch messages whenever activeChat changes
  useEffect(() => {
    const fetchChatData = async () => {
      if (!activeChat || !activeChat.id) return;

      try {
        const response = await api.get(
          `${getRoute('users', 'user', 'message', false)}?receiver=${
            activeChat.id
          }`
        );

        if (Array.isArray(response.data)) {
          setMessages(response.data);
        }
      } catch (error) {
        console.error('Error fetching chat data:', error);
        toast.error('Failed to fetch messages.');
      }
    };

    fetchChatData();
  }, [activeChat]);
  // ✅ Mark messages as read when chat becomes active
  useEffect(() => {
    const markMessagesAsRead = async () => {
      if (!activeChat || !activeChat.id) return;

      try {
        await api.put(
          getRoute('users', 'user', 'message', false) + `/mark-read`,
          {
            sender: activeChat.id,
            receiver: loggedInUserId,
          }
        );
        fetchUnreadCounts();
      } catch (error) {
        console.error('Error marking messages as read:', error);
      }
    };

    markMessagesAsRead();
  }, [activeChat]);

  useEffect(() => {
    if (!messages.length || !activeChat) return;

    const lastMsg = messages[messages.length - 1];
    if (lastMsg.sender === activeChat.id) {
      api
        .put(getRoute('users', 'user', 'message', false) + `/mark-read`, {
          sender: activeChat.id,
          receiver: loggedInUserId,
        })
        .then(fetchUnreadCounts);
    }
  }, [messages]);

  useEffect(() => {
    const handleReceiveMessage = (data) => {
      if (!data || !data.content) return;

      // ✅ Only show message if it belongs to the active chat
      const isRelevant =
        (data.sender === activeChat?.id && data.receiver === loggedInUserId) ||
        (data.receiver === activeChat?.id && data.sender === loggedInUserId);

      if (isRelevant) {
        setMessages((prev) => [...prev, data]);
      }

      // ✅ If it’s from another chat, just update unread counts instead
      if (data.sender !== activeChat?.id) {
        fetchUnreadCounts();
      }
    };

    socket.on('receiveMessage', handleReceiveMessage);
    fetchUnreadCounts();

    return () => {
      socket.off('receiveMessage', handleReceiveMessage);
    };
  }, [activeChat]);

  const handleSendMessage = async () => {
    if (!currentMessage) {
      return;
    }

    const data = {
      receiver: activeChat.id,
      content: currentMessage,
    };

    try {
      const response = await api.post(
        getRoute('users', 'user', 'message', false),
        data
      );
      socket.emit('sendMessage', response.data);
      setCurrentMessage('');
    } catch (error) {}
  };
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };
  return (
    <div className="bg-gray-50 h-screen flex flex-col gap-3 overflow-hidden font-customFont">
      {/* Team Messages Card */}
      {/* <div
        id="plist"
        className={`${
          isMobileView ? (showChatPanel ? 'hidden' : 'w-full') : 'w-1/4'
        }`}
      >
        <div
          className="group relative m-3 overflow-hidden border border-blue-200 
               bg-gradient-to-br from-blue-50 via-white to-blue-100 
               shadow-lg rounded-2xl p-4 transition-all duration-300"
        >
          <div className="absolute top-0 right-0 w-40 h-40 bg-blue-200 rounded-full -mr-14 -mt-14 opacity-20"></div>

          <div className="flex items-center justify-between mb-4 relative z-10">
            <div className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-md">
                <i className="fa-solid fa-comments text-white text-lg"></i>
              </div>
              <div>
                <p className="text-blue-700 text-lg font-bold uppercase tracking-wide">
                  Chat
                </p>
                <p className="text-blue-600 text-sm font-medium">
                  Conversations
                </p>
              </div>
            </div>
          </div>

          <ul className="relative z-10 space-y-3">
            <li
              onClick={() => {
                setActiveChat({
                  type: 'subuser',
                  id: parentId,
                  name: parentName,
                });
                if (isMobileView) setShowChatPanel(true);
              }}
              className={`flex items-center justify-between p-3 rounded-xl cursor-pointer 
          transition-all duration-300
          ${
            activeChat?.id === parentId
              ? 'bg-blue-600 text-white shadow-md'
              : 'bg-white/70 hover:bg-white hover:shadow-md'
          }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-11 h-11 flex items-center justify-center rounded-full shadow
              ${
                activeChat?.id === parentId
                  ? 'bg-blue-500 border-2 border-blue-300'
                  : 'bg-white border-2 border-blue-200'
              }`}
                >
                  <span
                    className={`font-bold text-lg capitalize
                ${
                  activeChat?.id === parentId ? 'text-white' : 'text-blue-700'
                }`}
                  >
                    {parentName?.charAt(0) || '?'}
                  </span>
                </div>

                <div>
                  <p
                    className={`font-semibold capitalize
                ${
                  activeChat?.id === parentId ? 'text-white' : 'text-blue-800'
                }`}
                  >
                    {parentName || 'Unknown User'}
                  </p>
                </div>
              </div>

              {unreadCounts[parentId] > 0 && (
                <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow animate-pulse">
                  {unreadCounts[parentId]}
                </span>
              )}
            </li>
          </ul>
        </div>
      </div> */}

      {/* Inbox: Chat */}
      <div
        className={`flex flex-col rounded-xl m-3 border shadow-lg overflow-hidden ${
          isMobileView ? (showChatPanel ? 'flex flex-1' : 'hidden') : 'flex-1'
        }`}
      >
        {activeChat ? (
          <>
            <div className="flex items-center justify-start rounded-t-xl p-4 bg-white border-b">
              {/* {isMobileView && (
                <button
                  className="mr-2 text-lg px-2 py-1"
                  onClick={() => setShowChatPanel(false)}
                >
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
              )} */}
              <div className="flex items-center">
                <div className="w-10 h-10 bg-[#E9EAEB] border border-[#E9EAEB] flex items-center justify-center rounded-full">
                  <span className="font-semibold text-xl text-[#535862]">
                    {activeChat.name.charAt(0)}
                  </span>
                </div>
                <div className="ml-3">
                  <h6 className="font-semibold text-lg text-black">
                    {activeChat.name}
                  </h6>
                </div>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto p-4 scrollbar-hidden">
              <ul className="space-y-4">
                {messages
                  .slice()
                  .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
                  .map((msg, index) => {
                    const msgDate = new Date(
                      msg.timestamp
                    ).toLocaleDateString();
                    const isToday = msgDate === new Date().toLocaleDateString();

                    const showDate =
                      index === 0 ||
                      new Date(
                        messages[index - 1].timestamp
                      ).toLocaleDateString() !== msgDate;

                    return (
                      <li key={index}>
                        {showDate && (
                          <div className="flex items-center my-2">
                            <div className="flex-grow border-t border-gray-300"></div>
                            <span className="mx-2 text-gray-500 ">
                              {isToday ? 'Today' : msgDate}
                            </span>
                            <div className="flex-grow border-t border-gray-300"></div>
                          </div>
                        )}
                        <div
                          className={`flex ${
                            msg.sender === loggedInUserId
                              ? 'justify-end'
                              : 'justify-start'
                          }`}
                        >
                          <div
                            className={`bg-${
                              msg.sender === activeChat
                                ? 'text-end'
                                : ' text-start'
                            } ml-3`}
                          >
                            <div className="flex gap-2">
                              {msg.sender !== loggedInUserId && (
                                <div className="w-10 h-10 bg-[#E9EAEB] mt-1 border border-[#E9EAEB] flex items-center justify-center rounded-full">
                                  <span className="font-semibold text-xl text-[#535862]">
                                    {activeChat.name.charAt(0)}
                                  </span>
                                </div>
                              )}
                              <div>
                                <div className="flex justify-between mb-1">
                                  <div className="text-xs font-semibold text-[#535862]">
                                    {msg.sender === loggedInUserId
                                      ? 'You'
                                      : activeChat.name}
                                  </div>
                                  <div className="flex items-end space-x-2 ml-3">
                                    <span className="text-xs  text-[#535862]">
                                      {new Date(
                                        msg.timestamp
                                      ).toLocaleTimeString()}
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className={`bg-${
                                    msg.sender === loggedInUserId
                                      ? 'themeColor text-white text-justify'
                                      : '[#F5F5F5] text-[#181D27] text-justify'
                                  } p-2 rounded-lg max-w-xs break-words`}
                                >
                                  {msg.content}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                <div ref={messagesEndRef}></div>
              </ul>
            </div>
            <div className="p-4">
              <div className="flex items-center">
                <div className="relative w-full">
                  <span className="absolute top-8 -translate-y-1/2 right-0 flex items-center pr-3 text-gray-400">
                    <img
                      src="../icons/SendMsg.svg"
                      alt="sendIcon"
                      onClick={
                        currentMessage.trim() ? handleSendMessage : undefined
                      }
                      className={`self-end ${
                        currentMessage.trim()
                          ? 'opacity-100 cursor-pointer'
                          : 'opacity-50 cursor-not-allowed'
                      }`}
                    />
                  </span>
                  <CustomInput
                    type="text"
                    value={currentMessage}
                    onChange={(e) => setCurrentMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className="pl-5 pr-4 py-5"
                    placeholder="Write a message..."
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex-1 flex flex-col h-full bg-gray-100 border-s relative">
            <div
              style={{
                background: 'rgba(228, 228, 228, 0.3',
                backdropFilter: 'blur(5px)',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
              }}
            />
            <div className="flex items-center justify-between p-4 bg-white border-b">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-themeColor3 text-gray-800 flex items-center justify-center rounded-full">
                  <span className="font-semibold text-xl">U</span>
                </div>
                <div className="ml-3">
                  <h6 className="font-semibold text-gray-800 text-2xl">User</h6>
                </div>
              </div>
            </div>
            <div className="flex-1 overflow-y-auto p-4">
              <ul className="space-y-4">
                <li className="flex justify-end">
                  <div className="flex items-end space-x-2">
                    <span className="text-xs text-gray-400">
                      10:10 AM, Today
                    </span>
                  </div>
                  <div className="bg-themeColor3 text-gray-800 p-3 rounded-lg max-w-xs ml-3">
                    Hi Aiden, how are you? How is the project coming along?
                  </div>
                </li>
                <li className="flex">
                  <div className="bg-gray-200 text-white p-3 rounded-lg max-w-xs ml-3">
                    Are we meeting today?
                  </div>
                  <div className="flex items-end space-x-2 ml-3">
                    <span className="text-xs text-gray-400">
                      10:12 AM, Today
                    </span>
                  </div>
                </li>
                <li className="flex">
                  <div className="bg-gray-200 text-white p-3 rounded-lg max-w-xs ml-3">
                    Project has been already finished and I have results to show
                    you.
                  </div>
                  <div className="flex items-end space-x-2 ml-3">
                    <span className="text-xs text-gray-400">
                      10:15 AM, Today
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="p-4 bg-gray-100">
              <div className="flex items-center">
                <i className="fa-solid fa-plus text-xl mr-3 text-themeColor cursor-pointer"></i>
                <div className="relative w-full">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                    <i className="fa-solid fa-paper-plane"></i>
                  </span>
                  <input
                    type="text"
                    className="pl-10 pr-4 py-2 w-full bg-white border rounded-lg text-sm focus:outline-none focus:ring focus:ring-themeColor3"
                    placeholder="Enter text here..."
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserChat;
